import React from 'react'
import { Outlet, BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import { useSelector, Provider } from 'react-redux'
import { store } from './store/store'
import { useMediaQuery } from '@mui/material'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { common } from '@mui/material/colors'
import CssBaseline from '@mui/material/CssBaseline'
import { ColorModeContext } from './contexts'

import ViewerHeader from './components/viewer/Header'
import Login from './components/login/Login'
import ResultList from './components/result/List'
import Viewer from './components/viewer/Viewer'

function MyNavigation(props) {
  let navigateTo = '/login'

  return <Navigate to={navigateTo} replace />
}

export default function App() {

  const storedThemeMode = localStorage.getItem('theme_mode')
  let themeMode = storedThemeMode
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)')
  if (storedThemeMode === null) {
    localStorage.setItem('theme_mode', prefersDarkMode ? 'dark' : 'light')
    themeMode = prefersDarkMode ? 'dark' : 'light'
  }
  const [mode, setMode] = React.useState(themeMode)
  localStorage.setItem('theme_mode', mode)
  const colorMode = React.useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'))
      },
    }),
    [],
  )
  
  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          mode: mode,
          ...(mode === 'light'
            ? {
                global: {
                  main: common.black,
                }
              }
            : {
              global: {
                  main: common.white,
                }
              }),
          white: {
            main: common.white,
          },
          black: {
            main: common.black,
          },
          ol: {
            main: "rgba(0,60,136,0.5)"
          }
        },
      }),
    [mode],
  )
  
  React.useEffect(() => {
    document.title = 'VisioGame'
  }, [])

  return (
    <BrowserRouter>
      <React.Suspense fallback={'Loading'}>
        <Routes>
          <Route exact path='/' element={
            <Provider store={store}>
              <MyNavigation/>
            </Provider>
          } />
          <Route path='/' element={
            <Provider store={store}>
              <ColorModeContext.Provider value={colorMode}>
                <ThemeProvider theme={theme}>
                  <CssBaseline />
                  <Outlet/>
                </ThemeProvider>
              </ColorModeContext.Provider>
            </Provider>
          } >
            <Route path='/login' element={<Login />} />
          </Route>
          <Route path='/' element={
            <Provider store={store}>
              <ColorModeContext.Provider value={colorMode}>
                <ThemeProvider theme={theme}>
                  <CssBaseline />
                  <ViewerHeader />
                </ThemeProvider>
              </ColorModeContext.Provider>
            </Provider>
          } >
            <Route path='/viewer' element={<Viewer />} />
            <Route path='/result' element={<ResultList />} />
          </Route>
          <Route path='*' element={<Navigate to='/' replace />} />
        </Routes>
      </React.Suspense>
    </BrowserRouter>
  );
}
